import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import momentJalaali from 'moment-jalaali';
import axios from 'src/app/Service/axios';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import * as XLSX from 'xlsx';
import * as moment from 'moment-jalaali';
declare let $: any;

@Component({
  selector: 'carInfo',
  templateUrl: './car_info.component.html',
  styleUrls: ['./car_info.component.css']
})


export class CarInfoComponent implements OnInit {

  constructor(

    private el: ElementRef,

    private notifyService: NotificationService,

    private router: Router,

    public otherService: OtherService,

    private formBuilder: FormBuilder,

    private route: ActivatedRoute,

    private _location: Location,

    private gurdService: GurdServiceService

  ) { }

  car: any;

  acssess: any;

  Id: number = 0;

  showLocation: boolean = false;

  api: string = '';

  hasGps: boolean = false;

  atrList: any;

  list_documentsType: any[] = [];

  list_documents: any[] = [];

  list_documents_Filter: any[] = [];

  lst_CommandList: any[] = [];

  lst_Search: any[] = [];

  lstChecked: any[] = [];

  bTankerMood: boolean = false;

  bTankerRoute: boolean = false;

  bAllOperations: boolean = true;

  bReportOperations: boolean = false;

  bFinancialOperations: boolean = false;

  bTankerOperations: boolean = false;

  bSalary: boolean = false;

  bFuelSensor: boolean = false;

  bWeightSensor: boolean = false;

  bTemperatureSensor: boolean = false;

  bShowResult: boolean = false;

  bFlowmeter: boolean = false;

  tanker_Calibration: boolean = false;

  weight_Calibration: boolean = false;

  isCommandList: boolean = true;

  bDocumentMode: 'addMode' | 'editMode' | 'documentMode' | 'viewMode' | 'deleteMode' = 'documentMode';

  deviceEvents: any;

  URL_SOURCE: any;

  reportOp_Title: string = 'لیست گزارش ها';

  webAppName = (<any>window).webAppName;

  insertUpdateForm: FormGroup = new FormGroup({

  });

  datasabt: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

  });

  datasabtStop: FormGroup = this.formBuilder.group({

    date: new Date().valueOf(),

    strEDate: new Date().valueOf(),

  });

  dataWorkAz: FormGroup = this.formBuilder.group({
    date: momentJalaali().format('jYYYY/jMM/01'),
  });

  dataWorkTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  dataTa: FormGroup = this.formBuilder.group({
    date: new Date().valueOf(),
  });

  dataAz: FormGroup = this.formBuilder.group({
    date: momentJalaali().format('jYYYY/jMM/01'),
  });

  documentModel: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    tiEvidenceType: new FormControl('', Validators.required),

    strExpireDate: new FormControl(''),

    iEvidenceDriver: new FormControl(''),

    strImage: new FormControl('', Validators.required),

    iEditItemIndex: new FormControl(''),

    strEvidenceType_strComment: new FormControl('')

  });

  mdl_Calibration: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    tiStatus: new FormControl('0'),

    tiType: new FormControl('1'),

    iFule: new FormControl('', Validators.required),

    strUnitID: new FormControl('', Validators.required),

  });

  mdl_NetConsumed: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

  });

  mdl_Consumption: FormGroup = this.formBuilder.group({

    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    strUnitID: new FormControl(''),

    strSDate: new FormControl('', Validators.required),

    strEDate: new FormControl('', Validators.required),

  });

  obj_NetConsumed: any;

  ngOnInit(): void {

    var data = window.localStorage.getItem("menu") as any;

    this.acssess = JSON.parse(this.gurdService.decrypt(data));

    this.route.params.subscribe(params => {

      this.Id = params['id'];

      this.mdl_Calibration.patchValue({

        strUnitID: this.Id

      })

      if (params['redirect']) this.URL_SOURCE = `/${params['redirect']}`;

      this.documentModel.controls['strUnitID'].setValue(this.Id)

      this.getCar();

    });

    this.route.queryParams.subscribe((data: any) => {

      if (data.Renewal) {

        this.checkOut_Contract();

      }

    })

    //timePicker

    setTimeout(() => {

      $('.clockpicker').clockpicker({

        donetext: 'top',

        align: 'top',

        autoclose: true,

      })

    }, 200);

  }

  async recallDistance() {
    $.confirm({
      title: `آیا از محاسبه نرم افزاری فاصله ها اطمینان دارید ؟`,
      content: 'این عملیات ممکن است تا یک دقیقه طول بکشد',
      type: 'red',
      buttons: {
        ok: {
          text: "تایید",
          btnClass: 'btn-success',
          keys: ['enter'],
          action: async () => {
            let model = {
              'iSystemUser': this.gurdService.decrypt(localStorage.getItem('ID')!),
              'strSession': this.gurdService.decrypt(localStorage.getItem('Session')!),
              'strUnitID': this.Id,
              'strSDate': this.dataWorkAz.value.date,
              'strEDate': this.dataWorkTa.value.date,
            }

            let icon = document.getElementById('recal') as HTMLElement;
            icon.classList.add('rotating');
            let res = JSON.parse((await axios.post(`ReCalDistance4ADate`, model)).data.toString());
            icon.classList.remove('rotating');

            this.notifyService.showSuccess('به روز رسانی با موفقیت انجام شد')
          }
        },
        cancel: {
          text: "لغو",
        }
      }
    });
  }

  reload() {
    window.location.reload();
  }

  changeApi = async (txt: any) => {

    this.api = txt;

    if (txt == 7 && !this.deviceEvents) {

      const resp = await axios.post(`GetDeviceEventsType`, {});

      this.deviceEvents = JSON.parse(resp.data);
    }

  }

  guid() {
    this.otherService.guid(36);
  }

  checkOut_Contract = async () => {

    var model = {

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id,

    };

    const resp_2 = await axios.post(`FleetYar_PayInvoice`, model);

    let res = JSON.parse(resp_2.data);

    if (res.iResult != 1) return this.notifyService.showError(res.strError);

    window.open(res.strURL, '_self');

  }

  getCar = async () => {

    var model = this.otherService.stringNumberToNumber({

      ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id,

    });

    const resp = await axios.post(`GetCar?strUnitID=${this.Id}`, model);

    if (resp.data.ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '12' } });

      return;

    }

    if (resp.data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    }

    if (resp.data.bExpired == true && !this.acssess.bEditExpiredDate) {

      const res = await axios.post(`Radyab_GetExpiredMessage`, this.otherService.stringNumberToNumber(model));

      let response = JSON.parse(res.data);

      $.confirm({

        title: `${response.strAmount}`,

        content: '',

        type: 'red',

        buttons: {

          cancel: {

            text: "بستن",

            btnClass: 'btn-outline-danger',

            action: function () { }

          },

          ok: {

            text: `تمدید`,

            btnClass: 'btn-success',

            keys: ['enter'],

            action: async () => {

              this.checkOut_Contract();

            }

          }

        },

        onOpenBefore: function () {

          if (response.bForcedRenewal) {

            this.buttons.cancel.disable(); // Manually disable the button
          }

        }

      });

    }

    else {

      if (resp.data.tiValidationStatus == 3) {

        $.confirm({

          title: `خودرو شما نیاز به اعتبار سنجی دارد. لطفا از طریق نسخه موبایل ${this.webAppName} و یا یکی از نمایندگی های شرکت، اقدام به اعتبار سنجی نمایید`,

          content: '',

          type: 'blue',

          buttons: {

            ok: {

              text: "بازگشت",

              btnClass: 'btn-primary',

              keys: ['enter'],

              action: async () => {

                window.location.href = '/'

              }

            },

          }

        });

      }

      else {

        this.datasabt.reset({

          date: resp.data.strDate

        });

        this.atrList = (resp.data.strAttribute || '').split(",")

        resp.data.fLastKM = parseInt(resp.data.fLastKM) || 0;

        resp.data.bActive == true ? resp.data.bActive = 'فعال' : resp.data.bActive = 'غیر فعال';

        resp.data.bACC == false ? resp.data.bACC = 'باز' : resp.data.bACC = 'بسته';

        resp.data.bonline == true ? resp.data.bonline = 'روشن' : resp.data.bonline = 'خاموش';

        let split = (resp.data.strVehicleNo || '').split(' ').filter(Boolean);

        resp.data.plak = split.length ? split : ['', '', '', '', ''];

        this.car = resp.data;

        // console.log(this.car)

        // this.car.tiMobileGroup = 232;

        localStorage.setItem('plate', this.gurdService.encrypt(this.car.plak))

        localStorage.setItem('hze', this.gurdService.encrypt(this.car.strMobileDomain_strComment))

        localStorage.setItem('vin', this.gurdService.encrypt(this.car.strVIN))

        this.hasGps = (this.car.bHasGPS || this.car.bOfficial) // ماشین اداری

        window.localStorage.setItem("carName", this.gurdService.encrypt(resp.data.strFullName))

        if (this.car.fLat == 0) {
          this.showLocation = true;
        }

        let adressModel = {
          fLat: this.car.fLat,
          fLon: this.car.fLon,
        }

        // const address = await axios.post(`ReverseGeocoding`, adressModel);

        const address = await axios.post(`ReverseGeocoding4FleetYar`, adressModel);

        this.car.strAddress = address.data.strAddress;


      }

    }

  };

  sabt() {

    $('#exampleModal').modal('hide');

    if (this.bTankerRoute) this.router.navigate([`tanker-route/${this.Id}`]);

    if (this.bTankerMood) this.router.navigate([`route/${this.Id}!`]);

    if (!this.bTankerMood && !this.bTankerRoute) this.router.navigate([`route/${this.Id}`]);

    this.bTankerMood = false;

    this.bTankerRoute = false;

    var Stime = document.getElementById("StimeR") as any;

    var Etime = document.getElementById("EtimeR") as any;

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(this.datasabt.value.date));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(Stime.value));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(Etime.value));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(this.Id.toString()));

  }

  sabt2() {

    if (this.mdl_NetConsumed.invalid) return this.notifyService.showError('فرم را با دقت تکمیل کنید.');

    window.localStorage.setItem("RouteSDate", this.gurdService.encrypt(this.mdl_NetConsumed.value.strSDate));

    window.localStorage.setItem("RouteEDate", this.gurdService.encrypt(this.mdl_NetConsumed.value.strEDate));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(this.Id.toString()));

    $('#exampleModal4_5').modal('hide');

    this.router.navigate([`tanker-route/${this.Id}*`]);


  }

  sabt3() {

    if (this.mdl_Consumption.invalid) return this.notifyService.showError('فرم را با دقت تکمیل کنید.');

    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.mdl_Consumption.value.strSDate));

    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.mdl_Consumption.value.strEDate));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(this.Id.toString()));

    $('#exampleModal4_6').modal('hide');

    // this.router.navigate([``]);

    window.open(`/report/${this.Id}/15-5`, '_blank')


  }

  saveCar(id: any) {

    this.router.navigate([`entryCar/${id}/${this.Id}`])
  }

  ReportStop() {

    if (!this.bTankerMood) {

      var Stime = document.getElementById("Stime") as any;

      var Etime = document.getElementById("Etime") as any;

      window.localStorage.setItem("reportStime", this.gurdService.encrypt(Stime.value));

      window.localStorage.setItem("reportEtime", this.gurdService.encrypt(Etime.value));

    }

    if (this.bTankerMood) window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.datasabtStop.value.strEDate));

    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.datasabtStop.value.date));

    $('#exampleModal3').modal('hide');

    $('#reportModal').modal('hide');

    if (this.api == "15") this.router.navigate([`report/${this.Id}/15`])

    else if (this.api == "15-1") this.router.navigate([`report/${this.Id}/15-1`])

    else if (this.api == "15-2") this.router.navigate([`report/${this.Id}/15-2`])

    else if (this.api == "15-3") this.router.navigate([`report/${this.Id}/15-3`])

    else if (this.api == "1-1") this.router.navigate([`report/${this.Id}/1-1`])

    else if (this.api == "1-2") this.router.navigate([`report/${this.Id}/1-2`])

    else this.router.navigate([`report/${this.Id}/1`])

  }

  goBack() {
    this._location.back();
  }

  reportWork() {
    var Stime = document.getElementById("clocks") as any;
    var Etime = document.getElementById("clocke") as any;
    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.dataWorkAz.value.date));
    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.dataWorkTa.value.date));
    window.localStorage.setItem("reportStime", this.gurdService.encrypt(Stime.value));
    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(Etime.value));
    $('#exampleModal3').modal('hide');
    $('#reportModal').modal('hide');
    $('#exampleModal4').modal('hide');
    this.router.navigate([`report/${this.Id}/2`])

  }

  get_Fueltank() {

    var Stime = document.getElementById("clocks") as any;

    var Etime = document.getElementById("clocke") as any;

    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.dataWorkAz.value.date));

    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.dataWorkTa.value.date));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(Stime.value));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(Etime.value));

    $('#exampleModal3').modal('hide');

    $('#reportModal').modal('hide');

    $('#exampleModal4_1').modal('hide');

    this.router.navigate([`report/${this.Id}/15-4`])


  }

  submit_Flowtrend() {

    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.mdl_Consumption.value.strSDate));

    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.mdl_Consumption.value.strEDate));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(this.Id.toString()));

    $('#exampleModal4_7').modal('hide');

    this.router.navigate([`report/${this.Id}/15-6`])


  }

  get_Refueling() {

    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.dataWorkAz.value.date));

    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.dataWorkTa.value.date));

    $('#exampleModal3').modal('hide');

    $('#reportModal').modal('hide');

    $('#exampleModal4_2').modal('hide');

    this.router.navigate([`report/${this.Id}/1-3`])


  }

  get_Discharge() {

    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.dataWorkAz.value.date));

    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.dataWorkTa.value.date));

    $('#exampleModal3').modal('hide');

    $('#reportModal').modal('hide');

    $('#exampleModal4_3').modal('hide');

    this.router.navigate([`report/${this.Id}/1-4`])


  }

  sabtdata() {
    window.localStorage.setItem("reportDataZa", this.gurdService.encrypt(this.dataAz.value.date));
    window.localStorage.setItem("reportDataTa", this.gurdService.encrypt(this.dataTa.value.date));
    if (this.api == "7") {
      var deviceEvents = document.getElementById("deviceEvents") as any;
      window.localStorage.setItem("deviceEvents", this.gurdService.encrypt(deviceEvents.value));
    }
    $('#exampleModal3').modal('hide');
    $('#reportModal').modal('hide');
    $('#exampleModal5').modal('hide');
    this.router.navigate([`report/${this.Id}/${this.api}`])
  }

  getSms = async (id: any) => {
    var model = {
      strUnitID: `${this.Id}`,
      iCommand: id,
      isystemUSer: this.gurdService.decrypt(localStorage.getItem('ID')!),
    }
    const resp = await axios.post(
      `App_Radyab_GetSMSCommand`,
      model
    );
    if (resp.data == "" || resp.data == null) {
      this.notifyService.showWarning("این دستگاه از این فرمان پشتیبانی نمیکند", "");
    }
    else {
      var sp = resp.data.split(";");
      if (sp.length == 3) {
        //this.notifyService.showInfo(sp[2],"");

        $.confirm({
          title: `${sp[2]}`,
          content: '',
          type: 'green',
          buttons: {
            ok: {
              text: "تایید",
              btnClass: 'btn-primary',
              keys: ['enter'],
              action: function () {
                window.location.href = `sms:${sp[0]}`
                navigator.clipboard.writeText(sp[1]);

              }
            },
            cancel: {
              text: "لغو",

            }
          }
        });
      }
      if (sp.length == 2) {
        this.notifyService.showInfo(sp[1], "");
      }
    }
  }

  openMap() {
    // If it's an iPhone..
    if ((navigator.platform.indexOf("iPhone") != -1)
      || (navigator.platform.indexOf("iPod") != -1)
      || (navigator.platform.indexOf("iPad") != -1))
      window.open(`maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${this.car.fLat},${this.car.fLon}`);
    else
      window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${this.car.fLat},${this.car.fLon}`);
  }

  salary() {
    $('#reportModal').modal('hide');
    this.router.navigate([`report/${this.Id}/14`]);

  }

  salaryBaseZone() {
    $('#reportModal').modal('hide');
    this.router.navigate([`report/${this.Id}/16`]);
  }

  sourceDestEarning(type?: number) {

    $('#reportModal').modal('hide');

    if (type) window.open(`report/${this.Id}/${type}`, '_blank')

    else this.router.navigate([`report/${this.Id}/${17}`]);

  }

  inspectionReport(type: string = '18') {

    $('#reportModal').modal('hide');

    window.open(`report/${this.Id}/${type}`, 'blank')

  }

  setQuickDate(
    formName: string,
    preset: 'today' | 'yesterday' | 'weekStart' | 'monthStart' | 'last7' | 'last30',
    controlName: string = 'date',
    endControlName?: string,
  ) {
    const form: FormGroup = (this as any)[formName];

    if (!form) return;

    const today = momentJalaali();

    let start = momentJalaali();

    switch (preset) {
      case 'today':
        start = momentJalaali();
        break;
      case 'yesterday':
        start = momentJalaali().subtract(1, 'day');
        break;
      case 'weekStart':
        start = momentJalaali().startOf('week');
        break;
      case 'monthStart':
        start = momentJalaali(momentJalaali().format('jYYYY/jMM/01'), 'jYYYY/jMM/jDD');
        break;
      case 'last7':
        start = momentJalaali().subtract(7, 'day');
        break;
      case 'last30':
        start = momentJalaali().subtract(30, 'day');
        break;
    }

    const startStr = start.format('jYYYY/jMM/jDD');

    const endStr = today.format('jYYYY/jMM/jDD');

    if (form.get(controlName)) form.get(controlName)!.setValue(startStr);

    if (endControlName && form.get(endControlName)) {
      form.get(endControlName)!.setValue(endStr);
    }

    this.activeChip[formName] = preset;
  }

  activeChip: any = {};

  isChipActive(formName: string, preset: string): boolean {
    return this.activeChip[formName] === preset;
  }

  getSensorState(type: string): { cls: string; label: string } {
    const c: any = this.car || {};
    switch (type) {
      case 'weight':
        return (c.fWeight || 0) > 0 ? { cls: 'ci-warn', label: 'در حال بار' } : { cls: 'ci-good', label: 'خالی' };
      case 'temp': {
        const t = c.iTemperature || 0;
        const ok = t >= -20 && t <= 80;
        return ok ? { cls: 'ci-good', label: 'عادی' } : { cls: 'ci-warn', label: 'غیرعادی' };
      }
      case 'voltage': {
        const v = c.fPower || 0;
        const ok = v >= 11 && v <= 30;
        return ok ? { cls: 'ci-good', label: 'مطلوب' } : { cls: 'ci-warn', label: 'نامطلوب' };
      }
      case 'battery': {
        const b = c.fBattery || 0;
        const ok = b >= 11;
        return ok ? { cls: 'ci-good', label: 'خوب' } : { cls: 'ci-warn', label: 'ضعیف' };
      }
      case 'fuel': {
        const f = c.iFuel || 0;
        return { cls: f > 30 ? 'ci-good' : 'ci-warn', label: f > 70 ? 'پر' : f > 30 ? 'عادی' : 'کم' };
      }
      case 'volume': {
        const ratio = c.fCapacity ? (c.fVolume || 0) / c.fCapacity : 0;
        return ratio > 0.1 ? { cls: 'ci-warn', label: 'در مخزن' } : { cls: 'ci-good', label: 'خالی' };
      }
      default:
        return { cls: 'ci-good', label: '' };
    }
  }

  async openDocumentModal() {

    this.documentModel.patchValue({

      tiEvidenceType: '',

      strExpireDate: '',

      strImage: '',

    })

    this.bDocumentMode = 'documentMode';

    this.otherService.Showspinner();

    const resp = await axios.post(`EvidenceType_List`, this.documentModel.value);

    let res = JSON.parse(resp.data);

    this.list_documentsType = res;

    const resp2 = await axios.post(`EvidenceDriver_List`, this.documentModel.value);

    let res2 = JSON.parse(resp2.data);

    this.list_documents = res2;

    this.list_documents_Filter = res2;

    this.otherService.nonespinner();

    $('#documentModal').modal('show');

  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.notifyService.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.documentModel.controls['strImage'].setValue(base64String.replace('data:image/jpeg;base64,', ''))

      };

    }


  }

  async documentOperation(item?: any, index?: number, event?: any) {

    if ((this.bDocumentMode == 'addMode' || this.bDocumentMode == 'editMode') && this.documentModel.invalid) return this.notifyService.showError('لطفا فرم را با دقت تکمیل کنید');

    if (this.bDocumentMode == 'addMode') {

      let res = JSON.parse((await axios.post(`EvidenceDriver_Save`, this.documentModel.value)).data.toString());

      if (res?.iResult == 0) return this.notifyService.showError(res.strError)

      this.list_documents.push(res.length ? res[0] : res);

      this.notifyService.showSuccess('با موفقیت اضافه شد')

      this.bDocumentMode = 'documentMode';

    }

    if (this.bDocumentMode == 'editMode') {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let res = JSON.parse((await axios.post(`EvidenceDriver_Edit`, this.documentModel.value)).data.toString());

              if (res?.iResult == 0) return this.notifyService.showError(res.strError)

              this.list_documents[this.documentModel.get('iEditItemIndex')?.value] = res[0];

              this.notifyService.showSuccess('با موفقیت ویرایش شد')

              this.bDocumentMode = 'documentMode';

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    if (this.bDocumentMode == 'viewMode' || this.bDocumentMode == 'deleteMode') {

      this.documentModel.controls['iEditItemIndex'].setValue(index)

      Object.keys(item).forEach(key => {

        this.documentModel.get(key)?.setValue(item[key])

      })
    }

    if (this.bDocumentMode == 'deleteMode') {

      $.confirm({

        title: `آیا از حذف اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'red',

        buttons: {

          ok: {

            text: "حذف",

            btnClass: 'btn-danger',

            keys: ['enter'],

            action: async () => {

              let res = JSON.parse((await axios.post(`EvidenceDriver_Delete`, this.documentModel.value)).data.toString());

              if (res?.iResult == 0) return this.notifyService.showError(res.strError)

              this.list_documents.splice(this.documentModel.get('iEditItemIndex')?.value, 1)

              this.notifyService.showSuccess('با موفقیت حذف شد')

              this.bDocumentMode = 'documentMode';

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    if (event && event != 'search') {

      if (event.target.value != -1) {

        this.list_documents_Filter = this.list_documents.filter((el: any) => {

          return el.tiEvidenceType == event.target.value

        })
      }

      else this.list_documents_Filter = this.list_documents;

    }

    if (event == 'search') {

      this.documentModel.patchValue({

        tiEvidenceType: '',

        strExpireDate: '',

        strImage: '',

      })

      this.bDocumentMode = 'addMode';
    }

  }

  editDocument(item: any, index: number) {

    this.bDocumentMode = 'editMode';

    this.documentModel.controls['iEditItemIndex'].setValue(index)

    Object.keys(item).forEach(key => {

      this.documentModel.get(key)?.setValue(item[key])

    })

  }

  selectOperation(target: string) {

    if (target == 'bAllOperations') {

      this.bFuelSensor = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bSalary = false;

      this.bTemperatureSensor = false;

      this.bWeightSensor = false;

      this.bFlowmeter = false;

      this.reportOp_Title = 'لیست گزارش ها';

      this.bAllOperations = true;

    }

    if (target == 'bReportOperations') {

      this.bFuelSensor = false;

      this.bAllOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bTemperatureSensor = false;

      this.bSalary = false;

      this.bFlowmeter = false;

      this.reportOp_Title = 'گزارش های عملیاتی';

      this.bReportOperations = true;

    }

    if (target == 'bFinancialOperations') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bTankerOperations = false;

      this.bSalary = false;

      this.bFuelSensor = false;

      this.bTemperatureSensor = false;

      this.bWeightSensor = false;

      this.bFlowmeter = false;

      this.reportOp_Title = 'گزارش های مالی و محدوده‌ای';


      this.bFinancialOperations = true;

    }

    if (target == 'bTankerOperations') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bSalary = false;

      this.bFuelSensor = false;

      this.bTemperatureSensor = false;

      this.bWeightSensor = false;

      this.bFlowmeter = false;

      this.reportOp_Title = 'گزارش های تانکر';


      this.bTankerOperations = true;

    }

    if (target == 'bSalary') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bFuelSensor = false;

      this.bWeightSensor = false;

      this.bTemperatureSensor = false;

      this.bFlowmeter = false;

      this.bSalary = true;

      this.reportOp_Title = 'گزارش ایاب ذهاب';



    }

    if (target == 'bFuelSensor') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bSalary = false;

      this.bWeightSensor = false;

      this.bTemperatureSensor = false;

      this.bFlowmeter = false;

      this.bFuelSensor = true;

      this.reportOp_Title = 'گزارش های سوخت';

      this.mdl_Consumption.patchValue({

        strSDate: moment().format('jYYYY/jMM/01'),

        strEDate: moment().format('jYYYY/jMM/jDD'),

      })

    }

    if (target == 'bWeightSensor') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bSalary = false;

      this.bFuelSensor = false;

      this.bTemperatureSensor = false;

      this.bFlowmeter = false;

      this.bWeightSensor = true;

      this.reportOp_Title = 'گزارش های وزن';



    }

    if (target == 'bTemperatureSensor') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bSalary = false;

      this.bFuelSensor = false;

      this.bWeightSensor = false;

      this.bFlowmeter = false;

      this.bTemperatureSensor = true;

      this.reportOp_Title = 'گزارش های دما';


    }

    if (target == 'bFlowmeter') {

      this.bAllOperations = false;

      this.bReportOperations = false;

      this.bFinancialOperations = false;

      this.bTankerOperations = false;

      this.bSalary = false;

      this.bFuelSensor = false;

      this.bWeightSensor = false;

      this.bTemperatureSensor = false;

      this.bFlowmeter = true;

      this.reportOp_Title = 'پایش فلومتر';


    }

  }

  goToTempAccess() {

    this.router.navigate(['tempAccess'], { queryParams: { id: this.Id } })
  }

  showAyab_Zahab(number: number) {

    $('#reportModal').modal('hide');

    this.router.navigateByUrl(`/ayab-zahab/${this.Id}/${number}`);

  }

  open_Calibration(bTanker: boolean = false, bWeightSensor: boolean = false) {

    this.tanker_Calibration = bTanker;

    this.weight_Calibration = bWeightSensor;

    this.mdl_Calibration.patchValue({

      tiStatus: 0,

      iFule: '',

    });

    $("#calibration_Modal").modal('show');

  }

  async submit_Calibration() {

    let model = this.otherService.stringNumberToNumber(this.mdl_Calibration.value);

    model.tiType = this.tanker_Calibration ? 2 : 1;

    model.tiType = this.weight_Calibration ? 3 : model.tiType;

    if (model.iFule == '' || model.iFule == 0) return this.notifyService.showError('مقدار سوخت موجود در باک را وارد کنید!');

    this.otherService.Showspinner();

    const resp = await axios.post(`FuelSensor_FuelQuantity_Save`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 1) {

      $("#calibration_Modal").modal('hide');

      return this.notifyService.showSuccess(res.strError);

    }

    if (res.iResult == 0) {

      $("#calibration_Modal").modal('hide');

      return this.notifyService.showError(res.strError);

    }

  }

  async get_NetConsumed() {

    this.mdl_NetConsumed.patchValue({

      strUnitID: this.Id

    })

    if (this.mdl_NetConsumed.invalid) return this.notifyService.showError('فرم را با دقت تکمیل کنید.');

    let model = this.otherService.stringNumberToNumber(this.mdl_NetConsumed.value);

    this.otherService.Showspinner();

    const resp = await axios.post(`Fueltank_NetConsumed`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.iResult == 0) return this.notifyService.showError(res.strError);

    this.obj_NetConsumed = res[0];

    $("#exampleModal4_4").modal('hide');

    $("#NetConsumed_Modal").modal('show');


  }

  async checkOutOnline_Status() {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id

    })

    this.otherService.Showspinner();

    const resp = await axios.post(`Dashcam_CheckOnline`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res == false) return this.notifyService.showError('ارتباط دوربین با سرور قطع می باشد');

    window.open(`/surveillance/${this.Id}`, '_blank');

  }

  filter_list(val: any) {

    this.lst_CommandList = this.lst_Search.filter((el: any) => {

      return el?.strTitle?.includes(val.value) ||

        el?.strCommandType?.toLowerCase()?.includes(val.value) ||

        el?.result_value?.toString().includes(val.value) ||

        el?.Column1?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_CommandList = this.lst_Search;

    }

  }

  async updateCommand(isCommandList: boolean) {

    const METHOD_URL = isCommandList ? 'Device_Commands_List' : 'Device_Commands_PreviousAnswers';

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.Id

    })

    this.otherService.Showspinner();

    const resp = await axios.post(`${METHOD_URL}`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12333310' } });

      return;

    }

    if (res.iResult == 0) {

      return this.notifyService.showError(res.strError);

    }

    this.isCommandList = isCommandList;

    this.lst_CommandList = res;

    this.lst_Search = res;

  }

  async sendSMS(item) {

    const smsLink = `sms:${this.car.strCellNo}?body=${encodeURIComponent(item.strCommand)}`;

    window.location.href = smsLink;

  }

  async sendGPRS(item) {

    $.confirm({

      title: `از انجام عملیات اطمینان دارید ؟`,

      content: '',

      type: 'green',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-success',

          keys: ['enter'],

          action: async () => {

            var model = this.otherService.stringNumberToNumber({

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              strUnitID: this.Id,

              strCommand: item.strCommand

            })

            this.otherService.Showspinner();

            const resp = await axios.post(`Device_Commands_SendViaGPRS`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: 'x12333310' } });

              return;

            }

            if (res.iResult == 0) {

              return this.notifyService.showError(res.strError);

            }

            else {

              this.updateCommand(false)

              return this.notifyService.showSuccess('با موفقیت ثبت شد');


            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  copyToClipboard(text: string): void {

    navigator.clipboard.writeText(text).then(() => {

      this.notifyService.showSuccess('کپی شد!')

      console.log('متن با موفقیت در کلیپ‌بورد کپی شد ✅');

    }).catch(err => {

      console.error('خطا در کپی کردن متن ❌', err);

    });

  }

  setCheckBox(value: boolean, item: any): void {

    const itemId = item.id;

    if (value === true) {

      // جلوگیری از اضافه شدن آیتم تکراری
      if (!this.lstChecked.includes(itemId)) {

        this.lstChecked.push(itemId);

      }

    } else {

      // حذف آیتم به صورت بهینه
      const index = this.lstChecked.indexOf(itemId);

      if (index !== -1) {

        this.lstChecked.splice(index, 1);

      }

    }

  }

  isSelected(item: any): boolean {

    return this.lstChecked.indexOf(item) !== -1;

  }

  async removeSelected() {

    $.confirm({

      title: `از انجام عملیات اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "تایید",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = this.otherService.stringNumberToNumber({

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              lstid: this.lstChecked

            })

            this.otherService.Showspinner();

            const resp = await axios.post(`Device_Commands_Delete`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.ISSessionExpired == true) {

              this.notifyService.showError('لطفا وارد سیستم شوید');

              this.otherService.removeLocalStorage();

              this.router.navigate(['login'], { queryParams: { error: 'x123s33310' } });

              return;

            }

            if (res.iResult == 0) {

              return this.notifyService.showError(res.strError);

            }

            else {

              this.updateCommand(false);

              this.lstChecked = [];

              return this.notifyService.showSuccess('با موفقیت انجام شد!');


            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  exportexcel(id: any): void {

    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'ExcelSheet.xlsx');
  }



}
